import { SVGInterface } from "../../interface";

const Floors1 = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6.5L6.5 2L2 6.5V22H4V20H9V22H11V12.9142H12.4818L18.4818 22H22V20H19.5182L13.5182 10.9142H11V6.5ZM9 18V16.5H4V18H9ZM9 12.9142V14.5H4V12.9142H9ZM9 7.32843V10.9142H4V7.32843L6.5 4.82843L9 7.32843Z"
      fill={color || "#0E171F"}
    />
    <path d="M13 18V22H15V18H13Z" fill={color || "#0E171F"} />
  </svg>
);

export default Floors1;
